module.exports = __webpack_public_path__ + "img/sj-s.5f6a75a6.png";